import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Recommend from './recommend';
import Subject from './subject';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { recommend, subject, asideAd },
        } = this.props;

        return (
            <div className={styles.rightContent}>
                <NoSSR>
                    <Chip
                        id="25024"
                        type="static"
                        title="栏目推荐"
                        groupName="侧栏"
                        translate="jsonParse"
                        content={recommend}>
                        <Recommend />
                    </Chip>
                </NoSSR>
                <Chip
                    id="55048"
                    type="recommend"
                    title="专题策划"
                    groupName="侧栏"
                    translate="handleSubjectData"
                    content={subject}>
                    <Subject />
                </Chip>
                <Ad content={asideAd} />
            </div>
        );
    }
}

export default errorBoundary(RightContent);
